import { render, staticRenderFns } from "./DemoMode.vue?vue&type=template&id=a8f061d4"
import script from "./DemoMode.vue?vue&type=script&lang=js"
export * from "./DemoMode.vue?vue&type=script&lang=js"
import style0 from "./DemoMode.vue?vue&type=style&index=0&id=a8f061d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports